<template>
  <v-dialog v-model="show"
            :transition="false"
            width="686"
  >
    <v-sheet class="mx-auto">
      <v-toolbar height="120">
        <v-btn icon width="80" height="88"
               disabled
        />

        <v-spacer />

        <v-toolbar-title>오렌즈 앱 업데이트 안내</v-toolbar-title>

        <v-spacer />

        <v-btn icon
               width="80"
               height="88"
               @click="show = false"
        >
          <v-icon size="50">
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12" class="text-subtitle-1">
            최신버젼으로 업데이트하시면 휴대폰본인인증 등의 문제가 해결됩니다.
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="text-subtitle-1"
                   height="88"
                   depressed block
                   @click="openAppUpdateUrl"
            >
              앱 업데이트 하러 가기
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-sheet>
  </v-dialog>
</template>

<script>

export default {
  name: 'AppUpdateDialog',
  components: {},
  props: {
    value: { type: Boolean, default: false },
    minDate: { type: Date, default: null },
    maxDate: { type: Date, default: null },
  },
  data: () => ({
    selectedDate: null,
  }),
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
  mounted () {
  },
  methods: {
    openAppUpdateUrl () {
      // eslint-disable-next-line no-undef
      NativeFunc.postMessage('openBrowser', '', 'market://details?id=com.olens.apps');
    }
  },
};
</script>